/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.24.0
 * @since 1.24.0
 */

import { LinkBlock } from '@/main/components/common';
import { TTableColumnCell } from '@modules/table/types';

import { TableCell } from '../index';
import TableCellNoValue from '../TableCellNoValue';
import { TTableCellLinkTooltipTextProps } from './types';

function TableCellLinkTooltipText<D extends object>(
    cell: TTableCellLinkTooltipTextProps<D>,
): Pick<TTableColumnCell<D>, 'Cell'> {
    return {
        Cell: (props) =>
            TableCell(props)({
                render: ({ row }) => {
                    const { noValue, children, ...linkProps } = cell(row);
                    return !noValue ? (
                        <LinkBlock {...linkProps}>
                            <div className="table__tooltip-text">{children}</div>
                        </LinkBlock>
                    ) : (
                        <TableCellNoValue />
                    );
                },
            }),
    };
}

export default TableCellLinkTooltipText;
